import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { getClientWorkers } from '../../reducers/clients';
import { history } from '../../configuration/store';
import SearchBar from '../../components/searchBar';
import Table from '../../components/table';
import messages from '../../text/messages';
import { getViceVersaFullName, getFullName } from '../../utilities/string';
import { dateToFloatingString, maxTimeSpan } from '../../utilities/dateTime';
import { RoleDefinitions } from '../../utilities/roles';

import './workers.css';

class WorkersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: ''
        };
        this.goToDetails = this.goToDetails.bind(this);
        this.filterResults = this.filterResults.bind(this);
    }

    componentDidMount() {
        const { profile, role, getClientWorkers, status } = this.props;
        const hmFilter = worker => (role.role === RoleDefinitions.ClientHiringManager.type ? worker.hm_id === profile.id : true) && worker.status === status;
        getClientWorkers(role.id, hmFilter, status);
    }

    goToDetails(worker) {
        const { role } = this.props;
        history.push(`/worker/${role.id}/${worker.contractor.id}/${worker.user.id}`);
    }

    getAddress(worker) {
        return worker.work_location_type !== 'offsite' ? worker.work_location_address.name : messages.workLocationRemote.defaultMessage;
    }

    getColumnDefinition() {
        return [
            {
                label: <FormattedMessage {...messages.worker} />,
                valueMap: worker => (
                    <div className="row name-column" onClick={() => this.goToDetails(worker)}>
                        {worker.user ? (
                            <div>
                                <div className="col-xs-12 name-cell ellipsis">
                                    <span>{getViceVersaFullName(worker.user)}</span>
                                </div>
                                <div className="col-xs-12 email-cell ellipsis">{worker.user.email}</div>
                            </div>
                        ) : (
                            <div className="col-xs-12 full-height-cell ellipsis">
                                <FormattedMessage {...messages.notProvided} />
                            </div>
                        )}
                    </div>
                ),
                size: 'col-lg-2  col-md-4  col-sm-4 col-xs-6',
                sort: (a, b) => getViceVersaFullName(a.user).localeCompare(getViceVersaFullName(b.user))
            },

            {
                label: <FormattedMessage {...messages.title} />,
                valueMap: worker => (
                    <div className="worker-title-cell ellipsis" onClick={() => this.goToDetails(worker)}>
                        <span className={`worker-classification-icon ${worker.classify_result}`}>{worker.classify_result}</span>
                        <span className="">{worker.title}</span>
                    </div>
                ),
                size: 'col-xs-2 hidden-xs',
                sort: (a, b) => a.title.localeCompare(b.title)
            },
            {
                label: <FormattedMessage {...messages.manager} />,
                valueMap: worker => (
                    <div className="row name-column" onClick={() => this.goToDetails(worker)}>
                        {worker.hm ? (
                            <div>
                                <div className="col-xs-12 name-cell ellipsis">
                                    <span>{getViceVersaFullName(worker.hm)}</span>
                                </div>
                                <div className="col-xs-12 email-cell ellipsis">{worker.hm.email}</div>
                            </div>
                        ) : (
                            <div className="col-xs-12 full-height-cell ellipsis">
                                <FormattedMessage {...messages.notProvided} />
                            </div>
                        )}
                    </div>
                ),
                size: 'col-lg-2 col-md-4  col-sm-4 col-xs-6',
                sort: (a, b) => getViceVersaFullName(a.hm).localeCompare(getViceVersaFullName(b.hm))
            },
            {
                label: <FormattedMessage {...messages.department} />,
                valueMap: worker => (
                    <div className="full-height-cell ellipsis" onClick={() => this.goToDetails(worker)}>
                        {worker.department ? <span> {worker.department} </span> : <FormattedMessage {...messages.notProvided} tagName={'span'} />}
                    </div>
                ),
                size: 'col-lg-2 hidden-sm hidden-md hidden-xs',
                sort: (a, b) => (a.department || '').localeCompare(b.department || '')
            },
            {
                label: <FormattedMessage {...messages.location} />,
                valueMap: worker => (
                    <div className="full-height-cell ellipsis" onClick={() => this.goToDetails(worker)}>
                        {worker.work_location_type !== 'offsite' ? (
                            <span>
                                {(worker.work_location_address || {}).name ? (
                                    <span>{worker.work_location_address.name}</span>
                                ) : (
                                    <FormattedMessage {...messages.notProvided} tagName={'span'} />
                                )}
                            </span>
                        ) : (
                            <FormattedMessage {...messages.workLocationRemote} tagName={'span'} />
                        )}
                    </div>
                ),
                size: 'col-lg-2 hidden-sm hidden-md hidden-xs',
                sort: (a, b) => this.getAddress(a).localeCompare(this.getAddress(b))
            },
            {
                label: <FormattedMessage {...messages.endDate} />,
                valueMap: worker => (
                    <div className="full-height-cell ellipsis" onClick={() => this.goToDetails(worker)}>
                        {worker.end_date ? (
                            <span>
                                {worker.end_date ? (
                                    <span>{dateToFloatingString(worker.end_date, 'MMMM D, YYYY')}</span>
                                ) : (
                                    <FormattedMessage {...messages.ongoing} tagName={'span'} />
                                )}
                            </span>
                        ) : (
                            <FormattedMessage {...messages.ongoing} tagName={'span'} />
                        )}
                    </div>
                ),
                size: 'col-xs-2 hidden-xs',
                sort: (a, b) => new Date(a.end_date || maxTimeSpan).getTime() - new Date(b.end_date || maxTimeSpan).getTime()
            }
        ];
    }

    filterResults() {
        const { employments } = this.props;
        const { searchString } = this.state;

        if (!searchString.trim()) {
            return employments;
        }

        let filter = searchString.toLowerCase();
        return employments.filter(
            e =>
                e.user.email.toLowerCase().includes(filter) ||
                getViceVersaFullName(e.user)
                    .toLowerCase()
                    .includes(filter) ||
                e.hm.email.toLowerCase().includes(filter) ||
                getFullName(e.hm)
                    .toLowerCase()
                    .includes(filter) ||
                e.title.toLowerCase().includes(filter) ||
                this.getAddress(e)
                    .toLowerCase()
                    .includes(filter) ||
                (e.department || '').toLowerCase().includes(filter)
        );
    }

    render() {
        const { employments } = this.props;
        if (!employments) return null;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                    </div>
                    <div className="col-sm-6 col-xs-12 add-wrapper">
                        <span className="button" onClick={() => history.push('/position/new')}>
                            <FormattedMessage {...messages.inviteWorker} />
                        </span>
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table
                        data={this.filterResults()}
                        rowStyle={'gl-table-body-row clickable-row'}
                        columns={this.getColumnDefinition()}
                        defaultSortColumn={0}
                    />
                </div>
            </React.Fragment>
        );
    }
}

WorkersList.defaultProps = {
    status: 'active'
};

const mapStateToProps = (state, props) => ({
    role: props.clientRole || state.identity.role,
    profile: state.identity.profile,
    employments: state.clients.workers
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClientWorkers: getClientWorkers
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(WorkersList);



// WEBPACK FOOTER //
// ./src/pages/positions/workers.jsx